import { render } from "./generalizationTable.vue?vue&type=template&id=bc99071a&scoped=true"
import script from "./generalizationTable.vue?vue&type=script&lang=js"
export * from "./generalizationTable.vue?vue&type=script&lang=js"

import "./generalizationTable.vue?vue&type=style&index=0&id=bc99071a&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc99071a"]])

export default __exports__